import { render, staticRenderFns } from "./InternalMovingMaterialTabs.vue?vue&type=template&id=16010c96&scoped=true"
import script from "./InternalMovingMaterialTabs.vue?vue&type=script&lang=js"
export * from "./InternalMovingMaterialTabs.vue?vue&type=script&lang=js"
import style0 from "./InternalMovingMaterialTabs.vue?vue&type=style&index=0&id=16010c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16010c96",
  null
  
)

export default component.exports